let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e222C")).then(() => parcelRequire('9LJAj'));